// when user clicks load button
// get session storage
// parse storage to become js array
// use same filters (by category, sorting, etc) - copy into sep js file
// for loop render all products if index is gt 5 (double check if starts at 0)
// append to the end of the table inside card - add an id to wrapper
// use bulk as html example
// if there is no session storage, do nothing

document.addEventListener('DOMContentLoaded', function () {
  // Get the View All button from CourseBoxMacro
  const viewAllBtn = document.querySelector('[data-category]');

  // Check if the button exists
  if (viewAllBtn) {
    viewAllBtn.addEventListener('click', function (e) {
      // console.log('View All button clicked for category:', viewAllBtn.getAttribute('data-category'));

      // Prevent default link behavior
      e.preventDefault();
      const category = viewAllBtn.getAttribute('data-category');
      // console.log('Category:', category);

      // Get sort type and order from data attributes, default to price/desc alternate is date/asc
      const sortType = viewAllBtn.getAttribute('data-sort-type') || 'price';
      const sortOrder = viewAllBtn.getAttribute('data-sort-order') || 'desc';

      // Get test price, coupon code, and group id from cookies (if available)
      const testPrice = cart.readCookie && cart.readCookie('_up4tp') ? `&testPrice=${cart.readCookie('_up4tp')}` : '';
      const couponCode = cart.readCookie && cart.readCookie('_up4cc') ? `&couponcode=${cart.readCookie('_up4cc')}` : '';
      const groupId = cart.readCookie && cart.readCookie('_up4gid') ? `&groupId=${cart.readCookie('_up4gid')}` : '';

      // Add loading state
      viewAllBtn.classList.add('btn-processing');

      // Build API URL with dynamic params
      const apiUrl = `apiURL_domain_replaced_during_build/Products/api/v2/Public/GetProductsBy/?host=jadelearning.com&unpublished=product_unpublished_replaced_during_build&fullSiteBuild=true${testPrice}${couponCode}${groupId}`;

      // console.log('API URL:', apiUrl);

      // Get all products from API and filter by category
      fetch(apiUrl)
        .then((res) => res.json())
        .then((productsData) => {
          // Filter products by marketingCategory
          const nonTestProducts = productsData.filter(
            (p) =>
              (Array.isArray(p.marketingCategory)
                ? p.marketingCategory.includes(category)
                : p.marketingCategory === category) && p.productCategory?.subCategoryName !== 'Test Product'
          );
          const productList = document.getElementById('product-list');
          // console.log('Filtered products for category:', nonTestProducts);

          // Get IDs of already displayed products
          const displayedProductList = Array.from(productList.querySelectorAll('[data-pid]')).map((el) =>
            el.getAttribute('data-pid')
          );

          // Exclude already displayed products
          let newProductList = nonTestProducts.filter((p) => !displayedProductList.includes(String(p.id)));

          // Remove state prefix from product name
          function removeStatePrefix(name) {
            const states = [
              'Alabama',
              'Alaska',
              'Arizona',
              'Arkansas',
              'California',
              'Colorado',
              'Connecticut',
              'Delaware',
              'Florida',
              'Georgia',
              'Hawaii',
              'Idaho',
              'Illinois',
              'Indiana',
              'Iowa',
              'Kansas',
              'Kentucky',
              'Louisiana',
              'Maine',
              'Maryland',
              'Massachusetts',
              'Michigan',
              'Minnesota',
              'Mississippi',
              'Missouri',
              'Montana',
              'Nebraska',
              'Nevada',
              'New Hampshire',
              'New Jersey',
              'New Mexico',
              'New York',
              'North Carolina',
              'North Dakota',
              'Ohio',
              'Oklahoma',
              'Oregon',
              'Pennsylvania',
              'Rhode Island',
              'South Carolina',
              'South Dakota',
              'Tennessee',
              'Texas',
              'Utah',
              'Vermont',
              'Virginia',
              'Washington',
              'West Virginia',
              'Wisconsin',
              'Wyoming',
            ];
            const trimmed = name.trim();
            const statePattern = states
              .sort((a, b) => b.length - a.length)
              .map((state) => state.replace(/ /g, '\\s+'))
              .join('|');
            const regex = new RegExp('^(' + statePattern + ')\\s+', 'i');
            return trimmed.replace(regex, '') || name;
          }

          // Sort by price or session date based on parameters
          if (sortType === 'price') {
            // console.log('Sorting by price:', sortOrder);
            newProductList.sort((a, b) => {
              const priceA = parseFloat(a.pricing?.price || 0);
              const priceB = parseFloat(b.pricing?.price || 0);
              if (priceA !== priceB) {
                return sortOrder === 'desc' ? priceB - priceA : priceA - priceB;
              }
              const nameA = (a.name || '').toLowerCase();
              const nameB = (b.name || '').toLowerCase();
              return nameA.localeCompare(nameB, undefined, { numeric: true });
            });
          } else if (sortType === 'date') {
            // console.log('Sorting by session date:', sortOrder);
            // Sort by session date (if session exists)
            newProductList.sort((a, b) => {
              // Always use SessionsJSONData if present, fallback to Sessions
              let aSessions = [];
              let bSessions = [];
              if (a.productSettings?.SessionsJSONData) {
                try {
                  const parsedA = JSON.parse(a.productSettings.SessionsJSONData);
                  if (Array.isArray(parsedA)) aSessions = parsedA;
                } catch (e) {}
              }
              if (!aSessions.length && Array.isArray(a.productSettings?.Sessions)) {
                aSessions = a.productSettings.Sessions;
              }
              if (b.productSettings?.SessionsJSONData) {
                try {
                  const parsedB = JSON.parse(b.productSettings.SessionsJSONData);
                  if (Array.isArray(parsedB)) bSessions = parsedB;
                } catch (e) {}
              }
              if (!bSessions.length && Array.isArray(b.productSettings?.Sessions)) {
                bSessions = b.productSettings.Sessions;
              }

              const aSession1 = aSessions.find((s) => s.SessionNumber === 1);
              const bSession1 = bSessions.find((s) => s.SessionNumber === 1);

              // If either session is missing, sort last
              if (!aSession1 && !bSession1) return 0;
              if (!aSession1) return 1;
              if (!bSession1) return -1;

              const aDate = new Date(aSession1.StartDate).getTime();
              const bDate = new Date(bSession1.StartDate).getTime();

              if (aDate !== bDate) {
                return sortOrder === 'desc' ? bDate - aDate : aDate - bDate;
              }
              const aName = (a.name || '').toLowerCase();
              const bName = (b.name || '').toLowerCase();
              return aName.localeCompare(bName, undefined, { numeric: true });
            });
          }

          if (productList && newProductList.length) {
            newProductList.forEach((product) => {
              // Need to know if product has tag "ilt" or "vilt"
              const hasILTTag =
                Array.isArray(product.tags) &&
                product.tags.some((tag) => {
                  const t = String(tag).toLowerCase();
                  return t === 'ilt' || t === 'vilt';
                });

              let instructor = '';
              let sessionsHtml = '';
              if (hasILTTag) {
                instructor = product.productSettings?.InstructorFirstName
                  ? `<p class="mb-1"><span class="fw-semibold">Instructor:</span> ${product.productSettings.InstructorFirstName} ${product.productSettings.InstructorLastName || ''}</p>`
                  : '';

                // Parse SessionsJSONData if present, fallback to Sessions
                let sessions = [];
                if (product.productSettings?.SessionsJSONData) {
                  try {
                    const parsed = JSON.parse(product.productSettings.SessionsJSONData);
                    if (Array.isArray(parsed) && parsed.length) {
                      sessions = parsed;
                    }
                  } catch (e) {
                    sessions = [];
                  }
                }
                if (!sessions.length && Array.isArray(product.productSettings?.Sessions)) {
                  sessions = product.productSettings.Sessions;
                }

                // Add formattedRange to each session if missing, using state for time zone
                const stateToTimeZone = {
                  Alabama: 'America/Chicago',
                  Alaska: 'America/Anchorage',
                  Arizona: 'America/Phoenix',
                  Arkansas: 'America/Chicago',
                  California: 'America/Los_Angeles',
                  Colorado: 'America/Denver',
                  Connecticut: 'America/New_York',
                  Delaware: 'America/New_York',
                  Florida: 'America/New_York',
                  Georgia: 'America/New_York',
                  Hawaii: 'Pacific/Honolulu',
                  Idaho: 'America/Boise',
                  Illinois: 'America/Chicago',
                  Indiana: 'America/Indiana/Indianapolis',
                  Iowa: 'America/Chicago',
                  Kansas: 'America/Chicago',
                  Kentucky: 'America/New_York',
                  Louisiana: 'America/Chicago',
                  Maine: 'America/New_York',
                  Maryland: 'America/New_York',
                  Massachusetts: 'America/New_York',
                  Michigan: 'America/Detroit',
                  Minnesota: 'America/Chicago',
                  Mississippi: 'America/Chicago',
                  Missouri: 'America/Chicago',
                  Montana: 'America/Denver',
                  Nebraska: 'America/Chicago',
                  Nevada: 'America/Los_Angeles',
                  'New Hampshire': 'America/New_York',
                  'New Jersey': 'America/New_York',
                  'New Mexico': 'America/Denver',
                  'New York': 'America/New_York',
                  'North Carolina': 'America/New_York',
                  'North Dakota': 'America/Chicago',
                  Ohio: 'America/New_York',
                  Oklahoma: 'America/Chicago',
                  Oregon: 'America/Los_Angeles',
                  Pennsylvania: 'America/New_York',
                  'Rhode Island': 'America/New_York',
                  'South Carolina': 'America/New_York',
                  'South Dakota': 'America/Chicago',
                  Tennessee: 'America/Chicago',
                  Texas: 'America/Chicago',
                  Utah: 'America/Denver',
                  Vermont: 'America/New_York',
                  Virginia: 'America/New_York',
                  Washington: 'America/Los_Angeles',
                  'West Virginia': 'America/New_York',
                  Wisconsin: 'America/Chicago',
                  Wyoming: 'America/Denver',
                };

                function getTimeZoneForState(state) {
                  return stateToTimeZone[state] || 'America/New_York';
                }

                function formatSessionDateRange(start, end, state) {
                  const timeZone = getTimeZoneForState(state);
                  const startDate = new Date(start);
                  const endDate = new Date(end);

                  const dateStr = startDate.toLocaleDateString('en-US', { timeZone });
                  const pad = (n) => n.toString().padStart(2, '0');
                  const startHourNum = parseInt(
                    startDate.toLocaleString('en-US', { hour: 'numeric', hour12: true, timeZone })
                  );
                  const endHourNum = parseInt(endDate.toLocaleString('en-US', { hour: 'numeric', hour12: true, timeZone }));
                  const startMinute = pad(startDate.toLocaleString('en-US', { minute: 'numeric', timeZone }));
                  const endMinute = pad(endDate.toLocaleString('en-US', { minute: 'numeric', timeZone }));

                  const startPeriod = startDate
                    .toLocaleString('en-US', { hour: 'numeric', hour12: true, timeZone })
                    .includes('PM')
                    ? 'PM'
                    : 'AM';
                  const endPeriod = endDate
                    .toLocaleString('en-US', { hour: 'numeric', hour12: true, timeZone })
                    .includes('PM')
                    ? 'PM'
                    : 'AM';

                  let tz = startDate.toLocaleTimeString('en-US', { timeZone, timeZoneName: 'short' }).split(' ').pop();
                  const tzMap = {
                    EST: 'Eastern',
                    EDT: 'Eastern',
                    CST: 'Central',
                    CDT: 'Central',
                    MST: 'Mountain',
                    MDT: 'Mountain',
                    PST: 'Pacific',
                    PDT: 'Pacific',
                  };
                  let tzFull = tz && tzMap[tz] ? tzMap[tz] : '';

                  return `${dateStr}, ${startHourNum}:${startMinute} ${startPeriod}–${endHourNum}:${endMinute} ${endPeriod}${tzFull ? ' ' + tzFull : ''}`;
                }

                sessions = sessions.map((session) => ({
                  ...session,
                  formattedRange:
                    session.formattedRange ||
                    (session.StartDate && session.EndDate
                      ? formatSessionDateRange(session.StartDate, session.EndDate, product.productSettings.State)
                      : ''),
                }));

                if (sessions.length === 1) {
                  sessionsHtml = `<p class="mb-0"><span class="fw-semibold">Date & Time:</span> ${sessions[0].formattedRange || ''}</p>`;
                } else if (sessions.length > 1) {
                  sessionsHtml =
                    `<ul class="mb-0">` +
                    sessions
                      .map((session) => `<li>Session ${session.SessionNumber}: ${session.formattedRange || ''}</li>`)
                      .join('') +
                    `</ul>`;
                }
              }

              // Calculate price before rendering HTML
              let displayPrice = product.pricing ? product.pricing.price : '';
              if (product.pricing && product.pricing.discountAmount > 0) {
                displayPrice = (product.pricing.price - product.pricing.discountAmount).toFixed(2);
              } else if (product.pricing) {
                displayPrice = Number(product.pricing.price).toFixed(2);
              }
              // Remove .00 but keep other decimals (e.g., 17.10 stays, 17.00 becomes 17)
              displayPrice = displayPrice.endsWith('.00') ? `$${displayPrice.slice(0, -3)}` : `$${displayPrice}`;

              // Show regular price only if there is a discount
              const discount =
                product.pricing && product.pricing.discountAmount > 0
                  ? `<span class="regular-price slashprice align-middle me-2 mb-1" data-pid="${product.id}">${Number(product.pricing.price).toFixed(2).endsWith('.00') ? '$' + Number(product.pricing.price).toFixed(0) : '$' + Number(product.pricing.price).toFixed(2)}</span>`
                  : '';

              // Get cartProducts from sessionStorage.localCart (only once per "View All Courses" click)
              const localCart = sessionStorage.getItem('localCart') ? JSON.parse(sessionStorage.getItem('localCart')) : null;
              const cartProducts = localCart ? localCart.cartProducts : [];

              // Check session storage for items in cart in localCart cartProducts productId
              const isInCart = cartProducts.some((item) => item.productId === product.id);
              // console.log('Is product in cart:', product.id, isInCart);

              // Similar details as ProductDetailsLine.njk
              const hours = product.productSettings?.Hours;
              const creditType = product.productSettings?.CreditType;
              const continuingEducationUnits = product.productSettings?.ContinuingEducationUnits;
              const courseFormat = product.productSettings?.CourseFormat;
              const approvalCode = product.productSettings?.CourseApprovalNumber;

              // Product details line HTML
              let detailsLine = '';
              detailsLine += `<div class="mt-2 mb-2 fw-600">`;
              if (hours) {
                const hourLabel = Number(hours) <= 1 ? 'hour' : 'hours';
                detailsLine += `<span>${hours} ${hourLabel}</span>`;
              }
              if (creditType) detailsLine += `<span> | ${creditType} Credits</span>`;
              if (continuingEducationUnits) {
                const ceuLabel = Number(continuingEducationUnits) <= 1 ? 'CEU' : 'CEUs';
                detailsLine += `<span> | ${continuingEducationUnits} ${ceuLabel}</span>`;
              }
              if (courseFormat) detailsLine += `<span> | ${courseFormat} Course</span>`;
              if (approvalCode) detailsLine += `<span> | Course Approval # ${approvalCode}</span>`;
              detailsLine += `</div>`;

              // Product HTML similar to fullTable macro
              let html = `
                <div class="card-table new-list mt-2 p-3 border-bottom" data-pid="${product.id}">
                  <div class="row justify-content-center">
                    <div class="col-md-8 mb-3 mb-md-0">
                      <h3 class="h4 text-theme-primary">${removeStatePrefix(product.name)}</h3>
                      ${detailsLine}
                      ${instructor}
                      ${sessionsHtml}
                      <div class="mb-2">
                        <div class="accordion description">
                          <span class="accordion-toggle small text-muted">View description</span>
                          <div class="accordion-content" style="display:none;">
                            <p>${product.description || ''}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="action pb-3 text-start text-md-end">
                        ${discount}
                        <span class="price-display mb-1" data-pid="${product.id}">${displayPrice}</span>
                        ${isInCart ? `<a class="add-to-cart-btn btn btn-outline-secondary ms-2 mb-1 view-cart-btn" href="https://cart.jadelearning.com/?cartId=${localCart.cartId}" data-pid="${product.id}" data-cart="add">View in Cart</a>` : `<a class="add-to-cart-btn btn btn-outline-secondary ms-2" href="https://cart.jadelearning.com/?productId=${product.id}" data-pid="${product.id}" data-cart="add">Add to Cart</a>`}


                      </div>
                    </div>
                  </div>
                </div>
              `;
              productList.insertAdjacentHTML('beforeend', html);
              cart.initAddToCartBtns();
            });

            // Hide button when no more products to load
            viewAllBtn.style.display = 'none';

            // Only attach listeners to dynamically inserted accordions inside #product-list
            productList.querySelectorAll('.card-table.new-list .accordion-toggle').forEach((toggle) => {
              toggle.removeEventListener('click', toggle._dynamicAccordionHandler || (() => {}));
              toggle._dynamicAccordionHandler = function (e) {
                e.preventDefault();
                this.classList.toggle('active');
                const accordionDesc = this.closest('.accordion.description');
                if (accordionDesc) accordionDesc.classList.toggle('is-open');
                const content = this.parentNode.querySelector('.accordion-content');
                if (content) {
                  const isOpen = content.style.display === 'block';
                  if (isOpen) {
                    // Animate closing
                    content.style.opacity = '0';
                    content.style.transform = 'scaleY(0.95)';
                    setTimeout(() => {
                      content.style.display = 'none';
                      content.style.opacity = '';
                      content.style.transform = '';
                    }, 200); // match your CSS transition duration
                  } else {
                    content.style.display = 'block';
                    content.style.opacity = '0';
                    content.style.transform = 'scaleY(0)';
                    setTimeout(() => {
                      content.style.opacity = '1';
                      content.style.transform = 'scaleY(1)';
                    }, 10); // allow display to apply before animating
                  }
                }
              };
              toggle.addEventListener('click', toggle._dynamicAccordionHandler);
            });
          }

          // Remove loading state after products are rendered
          viewAllBtn.classList.remove('btn-processing');
        })
        .catch(() => {
          // Remove loading state on error
          viewAllBtn.classList.remove('btn-processing');
        });
    });
  }
});
